import DropdownItem from 'emerald-ui/lib/DropdownItem';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: DropdownItem, componentName: 'DropdownItem' }], 'DropdownItem'),
  description: 'The DropdownItem is a menu item and should be used inside a DropdownMenu.',
  codeSamples: [
    {
      title: 'Default',
      scope: { DropdownItem },
      code: `<div
  style={{
    boxShadow: '0 2px 14px rgba(0, 0, 0, 0.21)',
    padding: '9px 0'
  }}
  role="menu"
>
  <DropdownItem header>Header</DropdownItem>
  <DropdownItem>Action</DropdownItem>
  <DropdownItem>Other action</DropdownItem>
  <DropdownItem separator />
  <DropdownItem header>Another header</DropdownItem>
  <DropdownItem>Some other action</DropdownItem>
  <DropdownItem icon="face">With icon</DropdownItem>
</div>`,
    },
  ],
};
